package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import org.vreo.devicehub.features.core.domain.device.webRtc.WebRtcOfferAnswer
import vreo.volt.protocol.WebRtcAnswer

/**
 * Extension function to map a [WebRtcOfferAnswer] to a [WebRtcAnswer].
 */
fun WebRtcOfferAnswer.toWebRtcConfigProto(): WebRtcAnswer {
    return WebRtcAnswer(
        sdp = this.sdp,
        type = this.type
    )
}

/**
 * Extension function to map a [WebRtcAnswer] to a [WebRtcOfferAnswer].
 */
fun WebRtcAnswer.toWebRtcConfig(): WebRtcOfferAnswer {
    return WebRtcOfferAnswer(
        sdp = this.sdp,
        type = this.type
    )
}